import axios from "axios";
import { servicePath } from "../../utility/data";

export const getLegacyServices = async (accessToken) => {

  try {
    const response = await axios.get(`${servicePath}/legacy`, {
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${accessToken}`
      },
    });

    return response;
  } catch (error) {
    console.error('Error:', error);
    throw new Error(error.response ? error.response.data.message : 'error to getting data');
  }
};


export const addLegacy = async (name, relation, accessToken) => {
  const payload = {
    "name": name,
    "relation": relation,
    "status": true,
  };

  try {
    const response = await axios.post(`${servicePath}/legacy`, payload, {
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${accessToken}`
      },
    });

    return response;
  } catch (error) {
    console.error('Error :', error);
    throw new Error(error.response ? error.response.data.message : 'not submit');
  }
};


export const updateLegacy = async (name, relation, legacy_id, accessToken) => {
  const payload = {
    "name": name,
    "relation": relation,
    "status": true,
  };

  try {
    const response = await axios.put(`${servicePath}/legacy/${legacy_id}`, payload, {
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${accessToken}`
      },
    });

    return response;
  } catch (error) {
    console.error('Error :', error);
    throw new Error(error.response ? error.response.data.message : 'not submit');
  }
};



export const deleteLegacy = async (accessToken, id) => {
  
  try {
    const response = await axios.delete(`${servicePath}/legacy/${id}`, {
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${accessToken}`
      },
    });

    return response;
  } catch (error) {
    console.error('Error during user registration:', error);
    throw new Error(error.response ? error.response.data.message : 'User registration failed');
  }
};


export const getItemsService = async (id, accessToken) => {

  try {
    const response = await axios.get(`${servicePath}/luxury-asset/get-items?luxury_asset_id=${id}`, {
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${accessToken}`
      },
    });

    return response;
  } catch (error) {
    console.error('Error:', error);
    throw new Error(error.response ? error.response.data.message : 'error to getting data');
  }
};


export const getJournalService = async (id, accessToken) => {

  try {
    const response = await axios.get(`${servicePath}/luxury-asset/journals?luxury_asset_id=${id}`, {
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${accessToken}`
      },
    });

    return response;
  } catch (error) {
    console.error('Error:', error);
    throw new Error(error.response ? error.response.data.message : 'error to getting data');
  }
};


export const getLegaciesService = async (id, accessToken) => {

  try {
    const response = await axios.get(`${servicePath}/luxury-asset/legacies?luxury_asset_id=${id}`, {
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${accessToken}`
      },
    });

    return response;
  } catch (error) {
    console.error('Error:', error);
    throw new Error(error.response ? error.response.data.message : 'error to getting data');
  }
};


export const addTransaction = async (transactionData, assetName, accessToken) => {

  const payload = {
    "date": transactionData.date,
    "type": transactionData.type,
    "luxury_asset_id": assetName.id ? assetName.id : null,
    "currency": transactionData.currency,
    "amount": transactionData.amount ? transactionData.amount : 0,
    "item_id": transactionData.addItem ? transactionData.addItem : 0,
    "reason": transactionData.reason,
    "remark": transactionData.reason, 
  };

  try {
    const response = await axios.post(`${servicePath}/luxury-asset/create-transaction`, payload, {
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${accessToken}`
      },
    });

    return response;
  } catch (error) {
    console.error('Error :', error);
    throw new Error(error.response ? error.response.data.message : 'not submit');
  }
};


export const getLuxaryTransaction = async (assetId, typeId, skip, limit, filterType, accessToken) => {

  try {
    const response = await axios.get(`${servicePath}/luxury-asset/get-transactions?luxury_asset_id=${assetId}&item_id=${typeId}&skip=${skip ? skip : 0}&limit=${limit ? limit : 10}`, {
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${accessToken}`
      },
    });

    return response;
  } catch (error) {
    console.error('Error:', error);
    throw new Error(error.response ? error.response.data.message : 'error to getting data');
  }
};


export const addMediaService = async (Media, related_id, itemId, type, accessToken) => {

  const formData = new FormData();

  if (Media.length > 0) {
    formData.append("file", Media[0].file);
  }

  try {
    const response = await axios.post(`${servicePath}/media?is_private=false&asset_type=LuxuryAsset&related_id=${related_id}&meta_key=${`luxury_asset_item`}&meta_value=${itemId}&type=${type}`, formData, {
      headers: {
        'Accept': 'application/json',
        // 'Content-Type': 'application/json',
        'Authorization': `Bearer ${accessToken}`
      },
    });

    return response;
  } catch (error) {
    console.error('Error :', error);
    throw new Error(error.response ? error.response.data.message : 'not submit');
  }
};


export const getMediaService = async (id, itemId, selectedButton, accessToken) => {

  try {
    const response = await axios.get(`${servicePath}/luxury-asset/get-medias?luxury_asset_id=${id}&item_id=${itemId}&type=${selectedButton}`, {
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${accessToken}`
      },
    });

    return response;
  } catch (error) {
    console.error('Error:', error);
    throw new Error(error.response ? error.response.data.message : 'error to getting data');
  }
};